var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-1",attrs:{"text":"","small":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("mdi-arrow-left")]),_vm._v(" Back ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }